import { useEffect } from 'react';

import { isCypressRun } from '~/utils/PathUtils';

export const useCypressHydrationMarker = () => {
  useEffect(() => {
    if (!isCypressRun()) {
      return;
    }

    // SSR-visible controls may not have React handlers yet, so Cypress needs an explicit post-hydration signal.
    document.documentElement.setAttribute('data-hydrated', 'true');

    return () => {
      document.documentElement.removeAttribute('data-hydrated');
    };
  }, []);
};
